<script>
  import contratoServico from '../servico';
  import projetoServico from '~modulos/projeto/servico';

  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  import DatePicker from 'vue2-datepicker';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalArquivosContrato from '~componentes/ModalArquivosContrato.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import Paginacao from '~componentes/Paginacao.vue';

  export default {
    components: { Paginacao, DatePicker, ModalArquivosSolicitacao, ModalMensagem, ModalArquivosContrato },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        contratos: [],
        carregando: true,
        filtros: this.camposFiltros(),
        projetos: [],
        solicitacaoSelecionada: null,
        animated: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        modalArquivos: false,
        modalMensagem: false,
        modalArquivosContratos: false,
        contratoSelecionado: null,
        exportando: false,
      }
    },
    computed: {
      fusp() {
        return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
      },
    },
    methods: {
      mostrarModalArquivosContratos(contrato) {
        this.contratoSelecionado = contrato;
        this.modalArquivosContratos = true;
      },
      fecharModalArquivosContratos() {
        this.animated = false;
        this.modalArquivosContratos = false;
        this.contratoSelecionado = null;
      },
      retornaID(id) {
        if (id > 0)
            return id

        return '---'
      },
      retornaTipo(tipo) {
        switch (tipo) {
          case 1: return "Bolsa";
            break;
          case 2: return "RPA";
            break;
          case 3: return "Estágio";
            break;
          case 5: return "Adicional variável";
            break;
          default:
            return "Contrato";
            break;
        }
      },
      retornaINSSPatronal(valor, tipo) {
        if (tipo != 2)
          return 0;

        return valor * 20 / 100;
      },
      retornaValorTotalContrato(valor, tipo) {
        if (tipo != 2)
          return valor;

        return valor + this.retornaINSSPatronal(valor, tipo)
      },
      camposFiltros() {
        return {
          idProjeto: '',
          periodo: '',
          numeroSolicitacao: '',
          contratada: '',
          filtrado: false,
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val('0');
          $('#projeto').trigger('change.select2');
        });

        this.lista();
      },
      filtrar() {
        this.filtros.filtrar = true;
        this.lista();
      },
      exportarExcel() {
        if (this.exportando) return;

        this.exportando = true;

        return contratoServico
          .listaLiberadosExcel(this.filtros)
          .then(arquivo => {
            this.exportando = false;

            if (arquivo === '') {
              this.$swal('', 'Nenhum contrato encontrado para exportar.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(() => {
            this.exportando = false;
            this.$swal('', 'Não foi possível gerar o Excel.', 'error');
          });
      },
      lista(pagina = 1) {
        this.carregando = true;

        return contratoServico.listaLiberados(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.contratos = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("SolBolsa")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
        this.lista(this.pagina);
      },
    },
    created() {
      if (this.$route.params.filtrosBag) 
        this.filtros = this.$route.params.filtrosBag;

      this.$root.botaoAcaoMostrar = false;
      this.$root.botaoRetrocederMostrar = false;
      this.lista(this.pagina);      
    },
    mounted() {
      this.$root.botaoAcaoMostrar = false;
      this.$root.botaoRetrocederMostrar = false;
      this.$root.tituloDaPagina = 'Contratos - Lista';    

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
      });

      if (this.$route.params.filtrosBag)
        if (this.filtros.filtrar)
          $('.ibox').removeClass('collapsed');
    },
    watch: {
      
    },
  }
</script>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada : ''"
                                tipo="bolsa"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-arquivos-contrato :mostrar="modalArquivosContratos"
                             :id="contratoSelecionado ? contratoSelecionado.idContrato : ''"
                             :mostrarDropzone="false"
                             @fechado="fecharModalArquivosContratos">
    </modal-arquivos-contrato>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoBolsa : ''"
                    tipo="SolBolsa"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="codigo">{{ 'Solicitação de ' +  configuracao.nomeModuloSolContratos }}</label>

                  <input type="text"
                         class="form-control"
                         id="codigo"
                         v-model="filtros.numeroSolicitacao"
                         v-numero>
                </div>
              </div>

              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label">Período</label>

                  <date-picker v-model="filtros.periodo"
                               input-class="form-control"
                               range
                               :editable="false"
                               lang="pt-br"
                               :confirm="true"
                               range-separator="a"
                               format="DD/MM/YYYY"
                               :shortcuts="false">
                  </date-picker>

                </div>
              </div>

              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="contratada">Contratada</label>

                  <input type="text"
                         class="form-control"
                         id="contratada"
                         maxlength="100"
                         placeholder="Nome ou parte do nome"
                         v-model="filtros.contratada"
                         @keyup.enter="filtrar">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-success no-margins" @click="filtrar">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                  <button type="button" class="btn btn-primary no-margins" @click="exportarExcel" :disabled="exportando">
                    <i :class="exportando ? 'fa fa-spinner fa-pulse' : 'fa fa-table'"></i>
                    {{ exportando ? 'Gerando relatório...' : 'Gerar listagem em excel' }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th>Solicitação</th>
                    <th>Tipo</th>
                    <th>Vigência início</th>
                    <th v-if="fusp">Vigência fim</th>
                    <th v-if="fusp">Vigência total</th>
                    <th>Contratada</th>
                    <th>Projeto</th>
                    <th>Complemento contrato</th>
                    <th>Valor contrato</th>
                    <th v-if="fusp">INSS Patronal</th>
                    <th v-if="fusp">Valor total contrato</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(contrato, index) in contratos">
                    <td>{{ retornaID(contrato.idSolicitacaoBolsa) }}</td>
                    <td>{{ retornaTipo(contrato.tipoContrato) }}</td>
                    <td>{{ contrato.dataContrato | formatarData }}</td>
                    <td v-if="fusp">{{ contrato.dataFimContrato | formatarData }}</td>
                    <td v-if="fusp">{{ contrato.dataTotalContrato | formatarData }}</td>
                    <td>{{ contrato.contratado || '---' }}</td>
                    <td>{{ contrato.nomeProjeto }}</td>
                    <td>{{ contrato.complementoContrato || '---' }}</td>
                    <td>{{ contrato.valor | formatarNumero }}</td>
                    <td v-if="fusp">{{ retornaINSSPatronal(contrato.valor, contrato.tipoContrato) | formatarNumero }}</td>
                    <td v-if="fusp">{{ retornaValorTotalContrato(contrato.valor, contrato.tipoContrato) | formatarNumero }}</td>
                    <td>
                      <router-link class="btn btn-primary btn-xs"
                                   active-class=""
                                   v-tooltip="'Visualizar'"
                                   :to="{ name: 'contrato.relatorio-liberados', params: { id: contrato.idContratoCrypt } }">
                        <i class="fa fa-file-text-o"></i>
                      </router-link>

                      <button type="button"
                              class="btn btn-info btn-xs"
                              v-tooltip="'Listar ou adicionar arquivos'"
                              @click="mostrarModalArquivos(contrato.idSolicitacaoBolsa)"
                              v-if="configuracao.usarArquivosSolicitacaoBolsa && contrato.idSolicitacaoBolsa">
                        <i class="fa fa-archive"></i>
                      </button>

                      <button type="button"
                              class="btn btn-info btn-xs"
                              v-tooltip="'Listar ou adicionar arquivos do contrato'"
                              @click="mostrarModalArquivosContratos(contrato)"
                              v-if="configuracao.usarArquivosContratos && !contrato.idSolicitacaoBolsa">
                        <i class="fa fa-archive"></i>
                      </button>

                      <button type="button"
                              class="btn btn-success btn-xs"
                              v-tooltip="'Ler\Enviar mensagem'"
                              @click="mostrarModalMensagem(contrato)"
                              v-if="(!configuracao.naoUtilizarMensageria && !configuracao.desativarMensageriaSolBolsa && contrato.idSolicitacaoBolsa)">
                        <i class="fa fa-comment"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="11">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/contrato/componentes/ContratoLiberados.vue